import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-material',
  templateUrl: './custom-material.component.html',
  styleUrls: ['./custom-material.component.css']
})
export class CustomMaterialComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
